"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import { EmailForwarder } from "./email_forwarder";
import FactorInvoicesService from "./factor_invoices_service";
import WaitingSpinner from "../components/waiting_spinner";
function findEmail(props, emailMessages) {
  if (props.emailId) {
    return emailMessages.find((e) => e.id === props.emailId) || null;
  }
  return emailMessages[0] || null;
}
class EmailForwarderWrapper extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      loading: true,
      email: null,
      error: null
    });
    __publicField(this, "fetchData", () => {
      FactorInvoicesService.fetchWithID(this.props.factorInvoiceId).then(
        (data) => {
          const email = findEmail(
            this.props,
            data.factor_invoice.email_messages || []
          );
          if (!email) {
            this.setState({ loading: false, error: "No email found to forward" });
            return;
          }
          this.setState({ loading: false, email });
        },
        () => {
          this.setState({ loading: false, error: "Failed to load invoice data" });
        }
      );
    });
  }
  componentDidMount() {
    this.fetchData();
  }
  render() {
    if (this.state.loading) {
      return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: true });
    }
    if (this.state.error) {
      return /* @__PURE__ */ React.createElement("div", { className: "email-forwarder__error" }, this.state.error);
    }
    return /* @__PURE__ */ React.createElement(
      EmailForwarder,
      {
        email: this.state.email,
        onCancel: this.props.onCancel,
        onDone: this.props.onDone
      }
    );
  }
}
export default EmailForwarderWrapper;
